<template>
  <section class="how-to-start">
    <h1 class="page-title">How to get Started</h1>
    <div class="steps">
      <div class="step step1">
        <div class="step-image">
          <img src="/images/step1.webp" class="how-step-img how-img" alt="Review Our Sim-Only Plans" />
        </div>
        <div class="copy">
          <div class="step-pill">Step 1</div>
          <h2 class="step-title">Review Our Sim-Only Plans</h2>
          <p class="step-text">
            Explore our range of SIM-only plans to find the perfect fit for your needs. Discover what’s included in each plan along with all the perks and special offers we have available. Whether you need more data, unlimited calls, or international roaming, we have a plan tailored for you.
          </p>
          <a href="/plans" class="how-step-btn">View All Plans ></a>
        </div>
      </div>
      <div class="step step2">
        <div class="step-image">
          <img src="/images/step2.webp" class="how-step-img how-img" alt="Review Our Sim-Only Plans" />
        </div>
        <div class="copy">
          <div class="step-pill">Step 2</div>
          <h2 class="step-title">Add Plan to Cart and Place Your Order</h2>
          <p class="step-text">
            Once you’ve selected your plan and SIM type, add them to your cart and proceed to checkout. Place your order, and your SIM will be delivered to you within a few days.
          </p>
          <a href="/plans" class="how-step-btn">View All Plans ></a>
        </div>
      </div>
      <div class="step step3">
        <div class="step-image">
          <img src="/images/step3.webp" class="how-step-img how-img" alt="Review Our Sim-Only Plans" />
        </div>
        <div class="copy">
          <div class="step-pill">Step 3</div>
          <h2 class="step-title">Activate Your SIM</h2>
          <p class="step-text">
            Upon receiving your SIM, you’ll get a QR code which will take you to our activation page (or click here) where you will need to log in and enter your Sim Serial Number (last 4 digits). That’s it—you’ll be ready to connect! It’s as simple as that!
          </p>
          <a href="/plans" class="how-step-btn">View All Plans ></a>
        </div>
      </div>
    </div>
  </section>

</template>

<style lang="scss" scoped>
.how-to-start {
  filter: drop-shadow(var(--box-shadow));

  h1, h2 {
    color: var(--peach);
  }

  .page-title {
    text-align: center;
    margin-bottom: 2rem;
  }

  .steps {
    display: flex;
    flex-direction: column;
    gap: 4rem;
    padding: 2rem;

    .step {
      display: flex;
      gap: 1.5rem;
      align-items: center;
      flex-wrap: wrap;

      > div {
        flex: 1 1 400px;
      }

      .copy {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        .step-pill {
          font-weight: 600;
          color: var(--peach);
          padding: 0.2rem 1rem;
          border: 2px solid;
          width: fit-content;
          border-radius: 100px;
          font-size: 1rem;
          filter: drop-shadow(var(--box-shadow));
        }

        p.step-text {
          font-size: 1rem;
        }

        .how-step-btn {
          font-weight: 600;
          color: var(--primary);
          text-decoration: none;

          &:hover {
            color: var(--banana);
          }
        }
      }

      .step-image {
        img {
          border-radius: 10px;
          border: 2px solid var(--peach);
        }
      }
    }
  }

  @media (min-width: 640px) {
    .step.step1, .step.step3 {
      flex-direction: row-reverse;
    }
  }
}

.how-img {
  max-width: 100%;
}

* {
  color: var(--primary);
}

</style>
